<template>
  <div class="wrapper">
    <div class="box">
      <div class="top">
        <p class="fund-name">{{ fundName }}</p>
      </div>
    <div class="middle">
      <p class="fund-code">{{ fundCode }}</p>
      <p class="tags">
        <span
        :style="tag"
        class="tag"
        v-for="(tag, index) in tags"
        :key="index"
        >{{ tag.tag }}</span>
      </p>
    </div>

    <div class="market-info">
      <!-- 新发基金 -->
      <div v-if="elementData && elementData.isNewFund" class="new-fund">
        <p  class="desc">{{
          highEndHeaderInfo.desc
        }}</p>
        <div
          v-if="highEndHeaderInfo.statusText !== '募集结束'"
          class="count-down"
        >
          <div
            v-for="(item, index) in timeDownArray"
            class="time"
            :key="`time-${index}`"
          >
            <p  class="value">{{ item.value }}</p>
            <p  class="unit">{{ item.unit }}</p>
          </div>
        </div>
      </div>
      <!-- 净值型固收  浮动收益-->
      <div v-else class="net-fixed-float-profit">
        <div class="net-fixed-float-profit-left">
          <p
            :style="{ color: highEndFundColor(highEndHeaderInfo.sylValue) }"
            class="net-fixed-float-profit-syl"
            >{{ highEndHeaderInfo.sylValue }}</p
          >
          <p class="desc">{{
            highEndHeaderInfo.sylDesc
          }}</p>
        </div>

        <div
          v-if="highEndHeaderInfo.middleDesc"
          class="net-fixed-float-profit-middle"
        >
          <p
            :style="{ color: highEndHeaderInfo.middleColor }"
            class="net-fixed-float-profit-middle-value"
            >{{ highEndHeaderInfo.middleValue }}</p
          >
          <div class="desc-box">
            <p  class="desc">{{
              highEndHeaderInfo.middleDesc
            }}</p>
            <img
              @click="clickTip(highEndHeaderInfo.middleDesc)"
              class="tip"
              src="https://j5.dfcfw.com/sc/image/202110/20211009012345.png"
            />
          </div>
        </div>

        <div
          :style="{
            alignItems: highEndHeaderInfo.middleDesc ? 'center' : 'flex-start',
          }"
          class="net-fixed-float-profit-right"
        >
          <p  class="net-fixed-float-profit-net">{{
            highEndHeaderInfo.netValue
          }}</p>
          <p  class="desc">{{
            highEndHeaderInfo.netDesc
          }}</p>
        </div>
      </div>
    </div>
    </div>
    <div
      class="new-fund-status-bg new-fund-status"
      v-if="elementData.isNewFund"
    >
      <p class="new-fund-status-text">{{
        highEndHeaderInfo.statusText
      }}</p>
    </div>
    <div class="bottom-info">
      <div v-if="!isEmpty(bottomInfo)" class="bottom-info">
        <div
          class="bottom-item"
          v-for="(item, index) in bottomInfo"
          :key="index"
        >
          <img class="icon" :src="item.icon" />
          <p  class="p">{{ item.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool';
import { throttle } from '@fund/basic-lib/dist/lib/function';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';

export default {
  name: 'high-end-header',

  props: {
    // 基金代码
    fundCode: String,
    // 外部传进来的组件数据
    elementData: Object,
    tradeData: Array, // 交易数据
    mergeData: Object, // 聚合数据
  },

  data() {
    return {
      timerId: undefined, // 定时器id
      timeDownArray: [
        {
          value: '--',
          unit: '天',
        },
        {
          value: '--',
          unit: '时',
        },
        {
          value: '--',
          unit: '分',
        },
        {
          value: '--',
          unit: '秒',
        },
      ], // 倒计时数组
      countDownChangeFlag: 0, // 倒计时变化 标志位 用于触发计算属性
    };
  },

  computed: {
    fundName() {
      return this.elementData?.fundName || '--';
    },

    tags() {
      return this.mergeData?.headerTags || [];
    },

    bottomInfo() {
      return this.mergeData?.headerBottomInfo || [];
    },

    // 高端头部信息
    highEndHeaderInfo() {
      const { countDownChangeFlag } = this;
      const newHighEndHeaderInfo = this.elementData?.newHighEndHeaderInfo || {};
      const {
        floatProfitAndNetFixedProfitHeaderInfo,
      } = this.mergeData;
      if (this.elementData?.isNewFund) {
        const { startTime, endTime } = newHighEndHeaderInfo;
        let statusText; let
          desc;
        // 缺省状态
        if (isEmpty(startTime) || isEmpty(endTime)) {
          return {
            status: 'error',
            statusText: '开放中',
            countDownChangeFlag,
            extraInfo: newHighEndHeaderInfo.extraInfo,
          };
        }

        const start = new Date(startTime.replace(/-/g, '/')).getTime();
        const end = new Date(endTime.replace(/-/g, '/')).getTime();
        const now = new Date().getTime();
        if (start - now > 0) {
          statusText = '即将开售';
          desc = '距离开售还有';
          this.countDown(start, 'start');
        } else if (start - now <= 0 && end - now >= 0) {
          statusText = '募集中';
          desc = '距离认购结束还剩';
          this.countDown(end, 'end');
        } else {
          statusText = '募集结束';
          desc = `${endTime}募集结束`;
        }
        return {
          statusText,
          desc,
          countDownChangeFlag,
          extraInfo: newHighEndHeaderInfo.extraInfo,
        };
      }
      return (
        floatProfitAndNetFixedProfitHeaderInfo || {
          sylDesc: '--',
          sylValue: '--',
          middleDesc: '--',
          middleValue: '--',
          middleDisplayValue: '--',
          netValue: '--',
          netDesc: '--',
        }
      );
    },
    // 计提业绩报酬类型
    achieveType() {
      const { redemAndAchieveInfo } = this.mergeData || {};
      const type = parseInt(redemAndAchieveInfo?.achieveType, 10);
      if (type === 1) {
        // 计提业绩报酬类型=1，且有值：卡片字段展示业绩报酬计提基准，展示信息说明弹窗
        return 'form';
      }
      if (type === 0) {
        return 'modal';
      }
      // 0,2,空保持线上
      return '';
    },
    // 业绩计提按钮
    performanceRule() {
      const { tradeRuleInfo, profitAnnual } = this.mergeData || {};
      // 兜底：原线上逻辑（业绩报酬计提基准-有值=>头部展示&不展示规则，业绩报酬计提基准-无值且有规则=>展示规则按钮）+业绩报酬计提类型=0隐藏
      if (
        isEmpty(tradeRuleInfo?.performanceRule)
        || !isEmpty(profitAnnual)
        || this.achieveType
      ) {
        return '';
      }
      return tradeRuleInfo.performanceRule;
    },
  },

  methods: {
    isEmpty,
    highEndFundColor: tool.highEndFundColor,
    // 监听消失和出现 改变导航栏
    headerAppear() {
      this.$customNavigationBar.setNavigationInfo({
        title: '基金详情',
      });
    },

    headerDisAppear() {
      this.$customNavigationBar.setNavigationInfo({
        title: this.elementData?.fundName || '--',
        subTitle: this.elementData?.fundCode || '-',
      });
    },

    // 倒计时
    countDown(time, status = 'start') {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        const res = tool.formatTime(time);

        // 倒计时清零 需要重新倒计时 或者结束倒计时
        if (res.isFinishCountDown) {
          this.countDownChangeFlag += 1;
          // 募集结束 通知页面重刷接口 通过数据修改头部 底部按钮状态
          // 清空计时器
          if (status === 'end') {
            throttle(
              () => {
                clearInterval(this.timerId);
                this.$layout.start();
              },
              1000,
              { leading: true },
            )();
          }
        }
        this.timeDownArray = res.timeDownArray;
      }, 1000);
    },

    clickTip(desc, isTipClick = true) {
      if (!isTipClick && desc.indexOf('业绩') === -1) {
        return;
      }
      let title = '';
      let content = '';
      const value = this.highEndHeaderInfo?.middleValue || '--';
      const overCarry = this.highEndHeaderInfo?.middleOverCarry || '--';
      if (desc.indexOf('业绩') >= 0) {
        title = '业绩报酬计提基准';
        content = `本期业绩报酬计提基准为 ${value}（不构成最低收益保证）\n\n如果业绩报酬计提期内年化收益率超出  ${value}，超出部分的${overCarry}% 将计提为管理人业绩报酬。`;
      } else {
        title = '成立来年化收益';
        content = '成立来年化收益=((1+成立来收益率)^(365/成立以来天数)-1)*100%\n\n成立以来天数=最新净值日期-第一次净值日期\n\n根据产品过往业绩，测算出年化回报，不代表未来实际收益率。';
      }

      multi.$feedback.showModal({
        title,
        content,
        confirmText: '我知道了',
        confirmColor: '#ff4400',
        showCancel: false,
      });
    },
    showPerformance() {
      multi.$feedback.showModal({
        title: '业绩报酬计提规则',
        content: `本产品业绩报酬计提规则：${this.performanceRule}\n\n本业绩报酬计提规则不构成最低收益保证。`,
        confirmText: '我知道了',
        showCancel: false,
        confirmColor: '#ff4400',
      });
    },
  },
};
</script>

<style scoped>
.tag-text {
  flex: 1;
  margin-left: 10px;
  font-family: PingFangSC-Regular;
  font-size: 22px;
  color: #7F3200;
  line-height: 22px;
}
.wrapper {
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  height: auto;
  background-color: #ffffff;
}

.box {
  padding: 38px 24px 26px;
  background-color: #ffffff;
}

.fund-name {
  max-width: 550px;
  font-family: PingFangSC-Medium;
  font-size: 38px;
  color: #000000;
  font-weight: bold;
}

.middle {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 12px;
  height: 42px;
}

.fund-code {
  font-family: DINAlternate-Bold;
  font-size: 28px;
  color: #999999;
  line-height: 28px;
}

.tags {
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow-x: auto;
  margin-left: 12px;
  /* line-height: 28px; */
}

.tag {
  white-space: nowrap;
  border-radius: 4px;
  padding: 6px 10px;
  margin-right: 10px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  text-align: center;
  color: #52a2ff;
  background-color: rgba(82, 162, 255, 0.1);
}

.diagnose-btn-p {
  font-family: PingFangSC-Medium;
  font-size: 24px;
  color: #a95619;
}
/*浮动货币*/
.currency {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  padding: 24px;
}

.left,
.right {
  flex: 1;
}

.zdf,
.syl {
  font-family: DINAlternate-Bold;
  font-size: 72px;
  color: #f24800;
}

/*固定收益*/
.fixed-profit {
  flex: 1;
  justify-content: center;
  align-items: center;
}

.fixed-profit-value {
  font-family: DINAlternate-Bold;
  font-size: 72px;
  color: #f24800;
}

.fixed-profit-desc {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.img {
  width: 28px;
  height: 28px;
  margin-left: 12px;
}

/*净值型固定收益*/
.net-fixed-float-profit {
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-left: 24px;
  margin-top: 32px;
}

.net-fixed-float-profit-left {
  display: flex;
  flex-direction: column;
  flex: 4;
  justify-content: flex-end;
}

.net-fixed-float-profit-middle {
  display: flex;
  flex-direction: column;
  flex: 6;
  justify-content: flex-end;
  align-items: center;
}

.net-fixed-float-profit-right {
  display: flex;
  flex-direction: column;
  flex: 4;
  justify-content: flex-end;
  align-items: center;
}

.net-fixed-float-profit-syl {
  font-family: DINAlternate-Bold;
  font-size: 56px;
  color: #000000;
  line-height: 72px;
  margin-bottom: 5px;
}

.net-fixed-float-profit-middle-value {
  font-family: DINAlternate-Bold;
  font-size: 36px;
  line-height: 36px;
  margin-bottom: 16px;
}

.desc-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.tip {
  /* px2wx:change next */
  width: 26px;
  height: 26px;
  margin-left: 4px;
}

.net-fixed-float-profit-net {
  font-family: DINAlternate-Bold;
  font-size: 36px;
  color: #000000;
  line-height: 36px;
  margin-bottom: 16px;
}

/*新发基金*/
.new-fund {
  margin-left: 24px;
  margin-top: 46px;
}

.count-down {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 16px;
}

.time {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.value {
  font-family: DINAlternate-Bold;
  font-size: 66px;
  color: #c89961;
  text-align: center;
}

.unit {
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #999999;
  text-align: justify;
  margin-left: 16px;
  margin-right: 16px;
}

.new-fund-status-bg {
  background: #ffdfdf;
  border-radius: 0 8px;
  padding: 4px 16px;
}

.new-fund-status-p {
  font-family: PingFangSC-Regular;
  font-size: 22px;
  color: #de3147;
  font-weight: 400;
}

.desc {
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #999999;
}

.bottom-info {
  width: 100%;
  margin-top: -1px;
  border: none;
  /* margin-left: 24px;
  margin-right: 24px; */
  height: 70px;
  background-image: linear-gradient(90deg, #fff1e1, #fce3ca);
  border-radius: 0 0 12px 12px;
  display: flex;
  flex-direction: row;
}

.bottom-item {
  height: 70px;
  flex: 1;
  height: 70px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.icon {
  width: 36px;
  height: 36px;
}

.p {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #a06946;
  margin-left: 8px;
}
.performance-arrow {
  width: 24px;
  height: 24px;
  margin-left: 8px;
}
.perf-btn {
  display: flex;
  flex-direction: row;
  background: #fff3e6;
  border-radius: 100px 0 0 100px;
  padding: 9px 28px;
  align-items: center;
}
.new-fund-status {
  position: absolute;
  right: 1px;
  width: 72px;
  height: 24px;
  justify-content: center;
  align-items: center;
}

.new-fund-status-text {
  font-family: PingFangSC-Regular;
  font-size: 22px;
  color: #de3147;
  text-align: right;
  font-weight: 400;
}
</style>
